// ============================================================================
// MY PERMISSIONS SERVICE
// ============================================================================
// Fetches the current user's effective permissions from the API.
// Used when REACT_APP_PERMISSION_SOURCE=local to populate permission context.

import { get } from '../client/axiosClient';
import { myPermissionsEndpoints } from '../endpoints/iam.endpoints';
import type { ApiResponse } from '../types';
import type { MyPermissionsDto } from '../types/iam.types';

class MyPermissionsService {
  /** Fetch current user's effective screen/element/action permissions */
  async getMyPermissions(): Promise<ApiResponse<MyPermissionsDto>> {
    const response = await get<ApiResponse<MyPermissionsDto>>(myPermissionsEndpoints.get());
    return response.data;
  }
}

export const myPermissionsService = new MyPermissionsService();
export default myPermissionsService;
